import React, { useContext, useEffect, useState } from "react";
import { StateApp } from "../context/Context";
import UpdateProfile from "../Login/UpdateProfile";
import SuccessImage from "../Modal/public/Success.svg";
import { requestForToken, readNotificationPermissionState } from "../firebase";

const SuccessLogin = () => {
    const [updateProfile, setUpdateProfile] = useState(false);
    const [notificationPermission, setNotificationPermission] = useState("unsupported");
    const [notificationLoading, setNotificationLoading] = useState(false);
    const [notificationError, setNotificationError] = useState("");
    const { completedProfile } = useContext(StateApp);

    useEffect(() => {
        let active = true;
        readNotificationPermissionState().then((state) => {
            if (active) setNotificationPermission(state);
        });
        return () => { active = false; };
    }, []);

    const handleUpdateProfile = () => {
        setUpdateProfile(true);
    };

    const handleEnableNotifications = async () => {
        if (notificationLoading) return;

        setNotificationLoading(true);
        try {
            const token = await requestForToken(localStorage.getItem("accessToken"), { requestPermission: true });
            setNotificationPermission(await readNotificationPermissionState());
            // Keep the home-page reminder in sync when permission is granted here.
            window.dispatchEvent(new Event("marankoo:notification-permission-updated"));
            if (!token) setNotificationError("ثبت اعلان انجام نشد. اتصال اینترنت و تنظیمات اعلان را بررسی کنید.");
            else setNotificationError("");
        } finally {
            setNotificationLoading(false);
        }
    };

    return (
        <>
            {updateProfile ? (
                <div>
                    <UpdateProfile />
                </div>
            ) : (
                <div>
                    <div className="rounded-[20px] bg-white w-[600px] h-[400px] md:w-full md:h-full p-4" style={{ fontFamily: "IRANSans" }}>
                        <div className="flex flex-col justify-center items-center">
                            <img className="mt-[32px]" src={SuccessImage} alt="ورود موفق" />
                            <div className="flex flex-col justify-center items-center">
                                <p className="text-[24px] mt-[18px] md:text-[20px]">
                                    تبریک میگم ورود شما با
                                    <span className="block text-center"> موفقیت انجام شد.</span>
                                </p>

                                {(notificationPermission === "prompt" || notificationPermission === "prompt-with-rationale") && (
                                    <button
                                        type="button"
                                        onClick={handleEnableNotifications}
                                        disabled={notificationLoading}
                                        className="mt-4 rounded-[10px] bg-darkBlue text-white px-5 py-2 disabled:opacity-60"
                                    >
                                        {notificationLoading ? "در حال فعال‌سازی..." : "فعال‌سازی اعلان‌های سفر"}
                                    </button>
                                )}

                                {notificationPermission === "granted" && (
                                    <p className="mt-4 text-[13px] text-green-700">اجازه اعلان‌های سفر داده شده است.</p>
                                )}

                                {notificationError && (
                                    <p className="mt-2 text-[13px] text-red-700 text-center">{notificationError}</p>
                                )}

                                {notificationPermission === "denied" && (
                                    <p className="mt-4 text-[13px] text-[#8A8D97] text-center">
                                        اعلان‌ها در تنظیمات مرورگر یا اپ غیرفعال شده‌اند و باید از همان بخش دوباره فعال شوند.
                                    </p>
                                )}

                                <div className="cursor-pointer mb-4" onClick={handleUpdateProfile}>
                                    {!completedProfile ? (
                                        <div>
                                            <p className="text-[16px] text-[#8A8D97] mt-[24px] md:text-[14px]">
                                                پروفایل شما کامل
                                                <span className="text-red-700"> نیست </span>
                                                برای تکمیل پروفایل خود کلیک کنید.
                                            </p>
                                        </div>
                                    ) : (
                                        <div>
                                            <p className="text-[16px] text-[#8A8D97] mt-[24px] md:text-[14px]">
                                                پروفایل شما کامل است.
                                                برای <span className="text-darkBlue">ویرایش</span> پروفایل خود کلیک کنید.
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default SuccessLogin;
